import React from "react";

/*eslint-disable */

declare const window: any;

interface ComunidadVehiculosComponentProps {
  comunidad: any;
  handleOpenModal: any;
}

const ComunidadVehiculosComponent: React.FC<
  ComunidadVehiculosComponentProps
> = ({ comunidad, handleOpenModal }) => {
  
  return (
    <div className="comunidad-vehiculos-detail-component">
      <div className="title-comunidad-vehiculos-detail-component">
        Comunidad Hyundai
      </div>
      <div
        className="colmena-comunidad-vehiculos-detail-component"
        style={{
          gridTemplateColumns: `${
            comunidad.length === 1
              ? "1fr"
              : comunidad.length === 2
              ? "repeat(2, 1fr)"
              : comunidad.length > 2
              ? "repeat(2, 1fr) 0.5fr"
              : "repeat(2, 1fr) 0.5fr"
          }`,
        }}
      >
        {comunidad.slice(0, 4).map((item: any, index: number) => (
          <div
            key={index}
            className="item-colmena-comunidad-vehiculos-detail-component"
            onClick={() => handleOpenModal()}
          >
            <img
              src={`https://manager.hyundaicolombia.co/${item?.front_image?.url}`}
              alt={item?.name ? `Imagen de ${item.name}` : "Imagen de vehículo Hyundai"}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComunidadVehiculosComponent;
